import { IMAGES } from "../../lzapp_web_common_code/assets";



export const APP_DOMAIN_LIST = [
  {
    id: 1,
    domain_name: "General Security Concepts",
    chapters: [1],
    exam_weightage: 10,
    show_proficiency: true,
    icon: "memory",
    requires_subscription: true,
    num_questions: 5,
    num_flashcards: 10,
  },
  {
    id: 2,
    domain_name: "Threats, Vulnerabilities, and Mitigations",
    chapters: [2],
    exam_weightage: 13,
    show_proficiency: true,
    icon: "lock",
    requires_subscription: true,
    num_questions: 5,
    num_flashcards: 10,
  },
  {
    id: 3,
    domain_name: "Security Architecture",
    chapters: [3],
    exam_weightage: 12,
    show_proficiency: true,
    icon: "tools",
    requires_subscription: true,
    num_questions: 5,
    num_flashcards: 10,
  },
  {
    id: 4,
    domain_name: "Security Operations",
    chapters: [4],
    exam_weightage: 8,
    show_proficiency: true,
    icon: "view-list",
    requires_subscription: true,
    num_questions: 5,
    num_flashcards: 10,
  },
  {
    id: 5,
    domain_name: "Security Program Management and Oversight",
    chapters: [5],
    exam_weightage: 7,
    show_proficiency: true,
    icon: "clipboard-list",
    requires_subscription: true,
    num_questions: 5,
    num_flashcards: 10,
  },
];

export const PRACTICE_TEST = [
  {
    id: 1,
    test_name: "Assessment Test",
    num_questions: 20,
    use_practice_test_id: true,
    practice_test_id: 1,
    icon: "memory",
    requires_subscription: false,
  },
  {
    id: 2,
    test_name: APP_DOMAIN_LIST[0].domain_name,
    num_questions: 20,
    topic_ids: [1],
    use_practice_test_id: true,
    practice_test_id: 2,
    icon: APP_DOMAIN_LIST[0].icon,
    requires_subscription: true,
  },
  {
    id: 3,
    test_name: APP_DOMAIN_LIST[1].domain_name,
    num_questions: 20,
    topic_ids: [2],
    use_practice_test_id: true,
    practice_test_id: 3,
    icon: APP_DOMAIN_LIST[1].icon,
    requires_subscription: true,
  },
  {
    id: 4,
    test_name: APP_DOMAIN_LIST[2].domain_name,
    num_questions: 20,
    topic_ids: [3],
    use_practice_test_id: true,
    practice_test_id: 4,
    icon: APP_DOMAIN_LIST[2].icon,
    requires_subscription: true,
  },
  {
    id: 5,
    test_name: APP_DOMAIN_LIST[3].domain_name,
    num_questions: 20,
    topic_ids: [4],
    use_practice_test_id: true,
    practice_test_id: 5,
    icon: APP_DOMAIN_LIST[3].icon,
    requires_subscription: true,
  },
  {
    id: 6,
    test_name: APP_DOMAIN_LIST[4].domain_name,
    num_questions: 20,
    topic_ids: [5],
    use_practice_test_id: true,
    practice_test_id: 6,
    icon: APP_DOMAIN_LIST[4].icon,
    requires_subscription: true,
  },
];
/** FLASH CARD MENU */
export const GET_FLASH_CARD_MENU = () => {
    return [
      {
        title: "Bookmark",
        icon_bg: "#FFEFED",
        image: IMAGES?.ic_flash_bookmark,
        menu: null,
        key: "bookmark",
        requires_subscription: false,
      },
      {
        title: "Quick Set (10)",
        icon_bg: "#E6FBFF",
        image: IMAGES?.ic_flash_quick_set,
        menu: null,
        key: "quick",
        requires_subscription: true,
      },
      {
        title: 'By Topics (Free Plan)',
        icon_bg: '#F3FFD9',
        key: 'by_topic_free_model',
        image: IMAGES?.ic_flash_topic,
        free_model: 1,
        menu: APP_DOMAIN_LIST
    },
    {
        title: 'By Topics (Premium Plan)',
        icon_bg: '#F3FFD9',
        key: 'by_topic',
        image: IMAGES?.ic_flash_topic,
        menu: APP_DOMAIN_LIST
    },
    ];
  };
  
  export const GET_STUDY_QUESTION_MENU = () => {
    return [
      {
        title: "Bookmark",
        icon_bg: "#FFEFED",
        image: IMAGES?.ic_flash_bookmark,
        key: "bookmark",
        menu: APP_DOMAIN_LIST
      },
      {
        title: "Quick Set (10)",
        icon_bg: "#E6FBFF",
        image: IMAGES?.ic_flash_quick_set,
        menu: null,
        key: "quick",
      },
      {
        title: 'By Topics (Free Plan)',
        icon_bg: '#F3FFD9',
        key: 'by_topic_free_model',
        image: IMAGES?.ic_flash_topic,
        free_model: 1,
        menu: APP_DOMAIN_LIST
    },
    {
        title: 'By Topics (Premium Plan)',
        icon_bg: '#F3FFD9',
        key: 'by_topic',
        image: IMAGES?.ic_flash_topic,
        menu: APP_DOMAIN_LIST
    },
    ];
  };
export const QUESTION_VERSION_OF_JSON = 1;
